import facebookLogo from '../assets/images/facebookLogo.svg'
import checkLight from '../assets/images/checklight.svg'

import { Typography, Box, Paper } from '@mui/material'
import { type CardProps } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import Btn from './Btn'
import { type MouseEventHandler } from 'react'

interface FacebookPlanProps extends CardProps {
  name: string
  impressions?: number
  price: number
  description: string
  details?: Array<{ text: string }>
  bntText?: string
  planBorder?: boolean
  handleClick?: MouseEventHandler<HTMLButtonElement>
}

const FacebookPlan: React.FC<FacebookPlanProps> = ({ name, impressions, price, description, details, bntText, planBorder = false, children, handleClick }) => {
  const theme = useTheme()
  function topColor (name: string): string {
    switch (name) {
      case 'Lite':
        return 'linear-gradient(90deg, #56D2FF 0%, #1D77F2 313.04%)'
      case 'Boost':
        return 'linear-gradient(90deg, #56D2FF -107.25%, #1D77F2 206.52%)'
      case 'Elite':
        return 'linear-gradient(90deg, #1ABFFB -210.87%, #1D77F2 100%)'
      default:
        return 'linear-gradient(90deg, #56D2FF 0%, #1D77F2 313.04%)'
    }
  }
  return (
    <Paper
      sx={{
        flex: '1 1',
        overflow: 'hidden',
        position: 'relative',
        boxShadow: 0,
        borderRadius: '10px',
        p: 0,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        border: planBorder ? '2px solid #EDEFF2' : 'none'
      }}
    >
      <Box
        sx={{
          width: '100%',
          height: 8,
          background: `${topColor(name)}`,
          top: 0,
          left: 0
        }}
      />
        <Box sx={{ p: 2 }}>
          <Box sx={{ pb: 2, display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
            <Box component='img' src={facebookLogo} />
            <Typography variant='h2' sx={{ mx: 1, color: theme.palette.grey[50] }}>{name}</Typography>
          </Box>
          <Box sx={{ m: 0, py: 2, px: 2, background: 'rgba(51, 191, 255, 0.05)', borderRadius: '10px' }}>
            <Typography align='center' variant="subtitle1" sx={{ color: theme.palette.grey[45] }}>{description}</Typography>
            { (impressions != null)
              ? <Typography align='center' sx={{ pt: 2, fontSize: 14, color: theme.palette.grey[45] }}>{impressions}+ ad impressions</Typography>
              : null
            }
          </Box>
          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>{ children }</Box>
          <Box sx={{ pt: (bntText === '') ? 0 : 3, pb: 1, display: 'flex', flexFlow: 'row', justifyContent: 'center', alignItems: 'flex-end' }}>
            <Typography sx={{ fontSize: 48, fontWeight: 500, color: theme.palette.grey[10] }}>${price}</Typography>
            <Typography sx={{ pl: '4px', pb: '15px', fontWeight: 500, color: theme.palette.grey[80] }}>/month</Typography>
          </Box>
          <Box sx={{ py: 0, px: 1 }}>
            { (bntText === '')
              ? null
              : <Btn variant='contained' color='secondary' text= {bntText ?? 'Subscribe'} onClick={handleClick} sx={{ width: '100%', py: '20px', mb: 4 }}/>
            }
            {details?.map((item, index) => {
              const { text } = item
              return (
                <Box key={index} sx={{ pb: 1, display: 'flex', flexFlow: 'row', alignItems: 'flex-start' }}>
                <Box component='img' src={checkLight} />
                <Typography sx={{ pl: 1, pb: 1, fontSize: 14, fontWeight: 500, lineHeight: '18px' }}>
                  {text}
                </Typography>
                </Box>
              )
            })}
          </Box>
        </Box>
    </Paper>
  )
}

export default FacebookPlan
